// Colors

import palette, { themeColorTokens } from '../palette';

export default {
  root: {
    backgroundColor: palette.background.default,
    '&:hover': {
      backgroundColor: themeColorTokens.infoLight,
    },
    '&$focused': {
      backgroundColor: themeColorTokens.infoLight,
    },
  },
};
